var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#2550AC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_5478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5152 14.6446L17.7591 9.69054C17.2314 9.30413 16.607 9.07139 15.9551 9.01812C15.3033 8.96484 14.6494 9.09312 14.066 9.38872C13.4825 9.68432 12.9924 10.1357 12.6498 10.6928C12.3072 11.25 12.1255 11.8911 12.125 12.5451V22.4582C12.124 23.1129 12.3047 23.755 12.6469 24.3131C12.9892 24.8712 13.4796 25.3234 14.0636 25.6193C14.6476 25.9151 15.3023 26.0432 15.9547 25.9891C16.6072 25.935 17.2318 25.7009 17.7591 25.3128L24.5152 20.3587C24.9635 20.0298 25.328 19.5998 25.5792 19.1038C25.8305 18.6077 25.9614 18.0595 25.9614 17.5035C25.9614 16.9474 25.8305 16.3992 25.5792 15.9031C25.328 15.4071 24.9635 14.9771 24.5152 14.6482V14.6446Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_5478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(10 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/startIcon.d21fb5bcca17d75cb7637073ea452b5d.svg";
export { ForwardRef as ReactComponent };